<div class="grid-outer-container">
  <div class="inner-container">
    <div class="loading-center">
      <div id="loadingMessage" class="section-h2 center">Logging in...</div>
      <div class="home-pg-loader cw-loader">
        <div class="cw-loader-line"></div>
      </div>
    </div>
  </div>
</div>
